import { useCallback } from 'react';

/**
 * @author taulmax
 * @date 2024.10.19
 * @description Select 컴포넌트
 */
const Select = ({
  selectRef,
  options,
  style,
  value,
  onChange,
  className,
  disabled = false,
}: {
  selectRef?: React.RefObject<HTMLSelectElement>;
  options: { value: string; option: string }[];
  style?: any;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  disabled?: boolean;
}) => {
  // Focus Event
  const onFocusSelect = useCallback(
    (e: React.FocusEvent<HTMLSelectElement>) => {
      e.target.parentElement?.classList.add('active');
    },
    []
  );

  // Blur Event
  const onBlurSelect = useCallback((e: React.FocusEvent<HTMLSelectElement>) => {
    e.target.parentElement?.classList.remove('active');
  }, []);

  return (
    <div
      className={`!relative ${className ? className : ''}`}
      style={{ ...style }}
    >
      <select
        ref={selectRef}
        onFocus={onFocusSelect}
        onBlur={onBlurSelect}
        className={`!w-full !px-3 !py-2 !border !border-gray-200 !rounded-md !text-sm !font-normal !text-gray-900 focus:!outline-none focus:!border-blue-500 !appearance-none !transition-colors !duration-200 ${disabled ? '!bg-gray-100 !cursor-not-allowed' : '!bg-white'}`}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {options.map((option, index) => (
          <option key={option.value + index} value={option.value}>
            {option.option}
          </option>
        ))}
      </select>
      <div className="!absolute !inset-y-0 !right-0 !flex !items-center !px-2 !pointer-events-none">
        <svg className="!w-5 !h-5 !text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
};

export default Select;
